import React from "react";
import './Info.scss';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Footer2 from "./Footer2";
import { reactLocalStorage } from "reactjs-localstorage";
import logo from "../assets/icons/logo.png"

const Info2 =(props)=>{
    const homeLogo = props.homeLogo
    const history = useHistory();
    console.log("history:::",history?.location?.state)
    const state=history?.location?.state?.status || reactLocalStorage.get("modal");
    console.log("State is:::",state)
    const message=history?.location?.state?.customMessage;

    return (
        <div className="containerinfo">
            <img src={homeLogo ? homeLogo : logo}
            className="logoinfo"
            alt="logo"/>

              <p className="para">{message}</p> 
            <div className="foot">
            <Footer2/>
        </div>
     </div>       
    );
}

export default Info2